import type { CalendarDate, Time } from "@internationalized/date";
import { DateTime } from "luxon";

export const isStartTimeSetToNow = (
	startDate: CalendarDate | undefined,
	startTime: Time | undefined,
	timezone: string,
): boolean => {
	if (!startDate || !startTime) {
		return false;
	}

	const currentDateTime = DateTime.now().set({ second: 0, millisecond: 0 }).setZone(timezone);
	const selectedDateTime = DateTime.fromFormat(
		`${startDate.toString()} ${String(startTime.hour).padStart(2, "0")}:${String(startTime.minute).padStart(2, "0")}:00`,
		"yyyy-MM-dd HH:mm:ss",
	);

	return selectedDateTime.hasSame(currentDateTime, "minute");
};
